<template>
    <v-data-table v-model="selectedItems" :headers="headers" :items="items" :items-per-page="itemsPerPage"
        :options.sync="options" :server-items-length="totalItems" :loading="isLoading" loader-height="2" item-key="id"
        show-select :loading-text="$t('loadingPleaseWait')" :no-data-text="$t('noOrders')"
        :no-results-text="$t('noResult')" :footer-props="{
            'items-per-page-text': $t('rowsPerPage'),
            'items-per-page-all-text': $t('all'),
        }">
        <template v-slot:item.actions="props">
            <router-link :to="{ name: 'Orders.Edit', params: { id: props.item.id } }" class="text-decoration-none">
                <v-icon dense>edit</v-icon>
            </router-link>
        </template>
    </v-data-table>
</template>

<script>
import { OrdersService } from '../../../services';
import { MixinTableLoadState } from '../../../mixins';

export default {
    name: 'OrdersTable',
    mixins: [MixinTableLoadState],
    props: {
        filters: {
            required: false,
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            headers: [],
            items: [],
            options: {},
            itemsPerPage: 10,
            totalItems: null,
        };
    },
    computed: {
        selectedItems: {
            get() {
                return this.$store.state.selectedOrders;
            },
            set(value) {
                this.$store.commit('setSelectedOrders', value);
            }
        }
    },
    methods: {
        setHeaders() {
            OrdersService.setLocale(this.$store.getters.appLanguage);
            OrdersService.getHeaders()
                .then(res => {
                    this.headers = res.data;
                })
                .catch(err => this.emitTableLoadError(err));
        },
        setItems() {
            if (!this.startTableLoading()) return;

            const params = { ...this.options, filters: this.filters };
            OrdersService.setLocale(this.$store.getters.appLanguage);
            OrdersService.getOrders(params)
                .then(res => {
                    this.items = res.data.data;
                    this.totalItems = res.data.total;
                })
                .catch(err => this.emitTableLoadError(err))
                .finally(() => {
                    this.stopTableLoading();
                });
        }
    },
    created() {
        this.setHeaders();
    },
    watch: {
        filters: {
            handler() {
                this.setItems();
            },
            deep: true,
        },
        options: {
            handler() {
                this.setItems();
            },
            deep: true,
        },
    },
}
</script>

<style scoped></style>
